import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { useCurrency } from '../contexts/CurrencyContext';

export const formatZAR = (amount) => {
  return new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
  }).format(amount);
};

export const formatMZN = (amount) => {
  return new Intl.NumberFormat('pt-MZ', {
    style: 'currency',
    currency: 'MZN',
  }).format(amount);
};

// Utility for converting with explicit rate (use in components via useCurrency hook)
export const convertToMZN = (zarAmount, rate = 4.6) => {
  return zarAmount * rate;
};

export const CurrencyDisplay = ({ 
  amountZAR, 
  showBoth = true, 
  size = 'default',
  className = '' 
}) => {
  const { language } = useLanguage();
  const { rate } = useCurrency();
  const amountMZN = amountZAR * rate;
  
  const sizeClasses = {
    small: 'text-sm',
    default: 'text-base',
    large: 'text-lg',
    xl: 'text-xl font-semibold',
  };

  if (!showBoth) {
    const amount = language === 'pt' ? amountMZN : amountZAR;
    const formatted = language === 'pt' ? formatMZN(amount) : formatZAR(amountZAR);
    return (
      <span className={`font-mono ${sizeClasses[size]} ${className}`} data-testid="currency-single">
        {formatted}
      </span>
    );
  }

  return (
    <div className={`currency-display ${className}`} data-testid="currency-display">
      <span className={`font-mono ${sizeClasses[size]} text-slate-900 dark:text-slate-100`}>
        {formatZAR(amountZAR)}
      </span>
      <span className={`font-mono ${size === 'xl' ? 'text-base' : 'text-sm'} text-slate-500 dark:text-slate-400 ml-2`}>
        ≈ {formatMZN(amountMZN)}
      </span>
    </div>
  );
};

export const CurrencyBadge = () => {
  const { rate } = useCurrency();
  return (
    <div 
      className="inline-flex items-center gap-1 px-2 py-1 bg-slate-100 dark:bg-slate-800 rounded text-xs font-mono"
      data-testid="currency-badge"
    >
      <span className="text-slate-600 dark:text-slate-400">1 ZAR</span>
      <span className="text-slate-400">=</span>
      <span className="text-[#F59E0B] font-medium">{rate} MZN</span>
    </div>
  );
};

export default CurrencyDisplay;
